import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { StoreConfig } from '../models/StoreConfig';
import userService from './user.service';

class StoreConfigsService {
  constructor() {
    this.collection = 'storeConfigs';
  }

  async getStoreConfig() {
    const store_id = await userService.getUserStoreId();
    const docRef = doc(db, this.collection, store_id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return StoreConfig.fromFirebase(docSnap);
    } else {
      // Create default config if it doesn't exist
      const defaultConfig = new StoreConfig({
        id: store_id,
        store_id,
        fillings: {},
      });
      await this.createStoreConfig(defaultConfig);
      return defaultConfig;
    }
  }

  async createStoreConfig(config) {
    const docRef = doc(db, this.collection, config.store_id);
    await setDoc(docRef, config.toJson());
    return config;
  }

  async updateStoreConfig(store_id, updates) {
    const docRef = doc(db, this.collection, store_id);
    await updateDoc(docRef, updates);
  }

  async upsertFilling(key, name, color, enabled = true) {
    const store_id = await userService.getUserStoreId();
    const docRef = doc(db, this.collection, store_id);
    const docSnap = await getDoc(docRef);
    
    let fillings = {};
    if (docSnap.exists()) {
      fillings = docSnap.data().fillings || {};
    }
    
    fillings[key] = {
      name,
      color,
      enabled,
    };
    
    if (docSnap.exists()) {
      await updateDoc(docRef, { fillings });
    } else {
      await setDoc(docRef, { store_id, fillings });
    }
  }

  async toggleFilling(key) {
    const store_id = await userService.getUserStoreId();
    const config = await this.getStoreConfig();
    config.toggleFilling(key);
    await this.updateStoreConfig(store_id, { fillings: config.fillings });
  }

  async deleteFilling(key) {
    const store_id = await userService.getUserStoreId();
    const config = await this.getStoreConfig();
    config.deleteFilling(key);
    await this.updateStoreConfig(store_id, { fillings: config.fillings });
  }

  async updatePrinterConfig(printerConfig) {
    const store_id = await userService.getUserStoreId();
    await this.updateStoreConfig(store_id, { printerConfig });
  }
}

const service = new StoreConfigsService();
export default service;
